import React from 'react';
import './AcceptTerms.pcss';
import CheckBox from '../../../../../../../common/components/Checkbox';
import { Routes } from '../../../../../../../routes/top-level-routes';

type Props = {
  onAagreedToTerms: (agreedToTerms: boolean) => void;
  isChecked: boolean;
  className?: string;
  showMSA?: boolean;
  disabled?: boolean;
};

export const AcceptTerms = ({
  onAagreedToTerms,
  isChecked,
  className,
  showMSA = false,
  disabled,
}: Props) => {
  return (
    <div className={className}>
      <CheckBox
        isChecked={isChecked}
        className="accept-terms__checkbox-wrapper"
        checkboxLabelTitleClassName="accept-terms__checkbox-label"
        name="termsAccepted"
        disabled={disabled}
        onToggle={() => onAagreedToTerms(!isChecked)}
        label={
          <>
            I have read and accept the{' '}
            {!showMSA && (
              <>
                <a
                  className="accept-terms__external-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ paddingRight: 0 }}
                  href={Routes.privacyPolicy.getLink()}
                >
                  <span className="accept-terms__bold">Privacy Policy</span>
                </a>
                &nbsp;and&nbsp;
                <a
                  className="accept-terms__external-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ paddingRight: 0 }}
                  href={Routes.masterServiceAgreement.getLink()}
                >
                  <span className="accept-terms__bold">Terms of Use</span>
                </a>
              </>
            )}
            {showMSA && (
              <a
                className="affiliate-panel__external-link"
                target="_blank"
                rel="noopener noreferrer"
                style={{ paddingRight: 0 }}
                href={Routes.masterServiceAgreement.getLink()}
              >
                Master Service Agreement (MSA)
              </a>
            )}
          </>
        }
      />
    </div>
  );
};
